import React from 'react'
import LucideIcon from '../lucideIcon'
import { Link } from 'react-router-dom'

export default function Services(props) {
  return (
    <div className={`topServices ${props.length == 1 ? 'first' : props.length == 2 ? 'second' : 'third'}`}>
      <div className="services">
        <LucideIcon name={props.image} className="lucideIconServices" />
        <h1>{props.name}</h1>
        <p>{props.comment}</p>
        <Link to={`${props.link}`}>{props.btn}</Link>
      </div>
    </div>
  )
}
